import React, { useState } from 'react';
import usePricingContext from 'contexts/pricing.context';
import CurrencyInput from 'components/base/currency-input';

const EditMealPricingForm = () => {
  const { mealPricingFormData, setMealPricingFormData, selectedMealPricing } = usePricingContext();
  const defaultShowVendorDetails = mealPricingFormData.reduce((result, _, index) => {
    result[index] = index === 0 ? true : false;
    return result;
  }, {} as Record<string, boolean>);
  const [showVendorDetails, setShowVendorDetails] = useState(defaultShowVendorDetails);

  const toggleShowVendorDetails = (idx: number) => {
    const show = showVendorDetails[idx];
    setShowVendorDetails((vendors) => ({
      ...vendors,
      [idx]: !show
    }));
  };
  const handleChange = ({ name, value }: { name: string; value: string }, index: number) => {
    setMealPricingFormData(
      mealPricingFormData.map((itm, i) => (i === index ? { ...itm, [name]: value } : itm))
    );
  };

  return (
    <div>
      <h3 className='text-xl font-semibold mb-8'>Update the new prices</h3>
      {mealPricingFormData?.map((item, vendorIndex) => (
        <div key={vendorIndex} className='mb-6'>
          <div className='bg-[#F7F7F7E5] border-b border-[#EAEBEB] py-3 mx-[-28px] flex justify-between'>
            <div className='flex flex-col gap-1 pl-[28px]'>
              <div className='flex gap-2'>
                <p className='text-[16px] font-semibold '>{item.ingredient?.name}</p>
              </div>
            </div>
            <div className='flex gap-2 pr-[28px]'>
              <div
                onClick={() => toggleShowVendorDetails(vendorIndex)}
                className='bg-white border border-[#EAEBEB] rounded-[100px] flex items-center justify-center  text-xs font-medium text-[#5E6164] cursor-pointer w-[61px] h-[30px] shadow-sm'>
                {showVendorDetails[vendorIndex] ? 'Hide' : 'Show'}
              </div>
            </div>
          </div>

          {showVendorDetails[vendorIndex] && selectedMealPricing?.id ? (
            <div className='flex justify-start items-center gap-6 w-[100%] mt-4'>
              <CurrencyInput
                label='Current selling price'
                value={item?.old_kitchen_price}
                onChange={(e) => handleChange({ name: 'old_kitchen_price', value: e }, vendorIndex)}
                disabled
                placeholder=' 2,000'
                containerClassname='w-full'
              />

              <CurrencyInput
                label='New Price'
                value={item?.kitchen_price}
                onChange={(e) => handleChange({ name: 'kitchen_price', value: e }, vendorIndex)}
                placeholder=' 2,000'
                containerClassname='w-full'
              />
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default EditMealPricingForm;
